import { render } from "./WorkSection.vue?vue&type=template&id=7690497c&scoped=true"
import script from "./WorkSection.vue?vue&type=script&lang=js"
export * from "./WorkSection.vue?vue&type=script&lang=js"

import "./WorkSection.vue?vue&type=style&index=0&id=7690497c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7690497c"]])

export default __exports__